import React from 'react';
import noop from 'lodash/noop';
import ModalManager from '../modal-manager';
import Modal from './Modal';
import { getContainer } from '../modal-container/ModalContainer';
import Icon from '../icon';
import { normalizeProps } from './utils';
export default async function confirm(props) {
    const container = await getContainer();
    const { children, type = 'confirm', onOk = noop, onCancel = noop, onClose = noop, iconType, border = false, okCancel = true, title, ...otherProps } = normalizeProps(props);
    const prefixCls = container.context.getProPrefixCls('confirm');
    const titleNode = title && React.createElement("div", { className: `${prefixCls}-title` }, title);
    const contentNode = children && React.createElement("div", { className: `${prefixCls}-content` }, children);
    const iconNode = iconType && (React.createElement("td", { className: `${prefixCls}-icon ${prefixCls}-${type}` },
        React.createElement(Icon, { type: iconType })));
    return new Promise(resolve => {
        Modal.open({
            key: ModalManager.getKey(),
            className: `${prefixCls}-wrapper`,
            border,
            destroyOnClose: true,
            okCancel,
            closable: false,
            movable: false,
            style: { width: '4.16rem' },
            children: (React.createElement("table", { className: prefixCls },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        iconNode,
                        React.createElement("td", null,
                            titleNode,
                            contentNode))))),
            onOk: async () => {
                const result = await onOk();
                if (result !== false) {
                    resolve('ok');
                }
                return result;
            },
            onCancel: async () => {
                const result = await onCancel();
                if (result !== false) {
                    resolve('cancel');
                }
                return result;
            },
            onClose: async () => {
                const result = await onClose();
                if (result !== false) {
                    resolve('cancel');
                }
                return result;
            },
            ...otherProps,
            resizable: false,
        });
    });
}
